module.exports = __webpack_public_path__ + "static/media/checkmark.daf47a9d.svg";